export const faqItems = [
  {
    q: '如何使用AI智能填报功能？',
    a: '进入AI智能填报页面，依次填写省份、科类、高考分数、全省位次和志愿偏好，然后点击AI智能分析。系统会生成冲、稳、保、兜底四层志愿方案，并展示院校、专业、历年录取数据和风险提示。',
  },
  {
    q: '免费用户和VIP会员有什么区别？',
    a: '免费用户可体验核心的AI方案生成、基础数据查询和风险检测。VIP会员可获得更高频次方案生成、高阶风险排查、深度答疑、就业数据分析、方案对比和导出等权益。',
  },
  {
    q: 'AI推荐的方案准确吗？',
    a: 'AI方案基于近年官方投档数据、位次波动、选科要求和个人偏好进行概率分析，但录取结果会受当年招生计划、报考热度和政策变化影响。推荐结果仅供辅助参考。',
  },
  {
    q: '分数和位次应该以哪个为准？',
    a: '位次通常比裸分更稳定。每年试卷难度不同，分数线会波动，但高校录取本质上按位次竞争。填报时建议以全省位次为主，分数作为辅助参考。',
  },
  {
    q: '如何保存和导出志愿方案？',
    a: '生成方案后会保存到个人中心的我的方案。你可以在方案列表查看详情、删除方案，后续也可扩展 PDF 或图片导出用于线下核对。',
  },
  {
    q: '数据来源是什么？多久更新一次？',
    a: '平台数据来自教育部、各省教育考试院、阳光高考平台和高校招生网等公开权威渠道。当前阶段使用 Mock 数据，正式接入后会按招生季节奏更新。',
  },
  {
    q: '如何联系客服？',
    a: '你可以先使用AI智能答疑模块查询常见问题。后续接入账户和工单系统后，将在帮助中心开放人工反馈入口。',
  },
];
